import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "using-source-code"
    }}>{`Using Source code`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Change folder to /var/www`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`cd /var/www
`}</code></pre>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Clone Git repository`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`git clone https://github.com/Cezerin3/Store
cd cezerin2
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Change settings`}</strong></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`This step is optional. You can skip this step, all works fine with default
settings.`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`cd config
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Open `}<inlineCode parentName="strong">{`config/server.js`}</inlineCode>{` and change`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">{`MongoDB Credentials`}</li>
          <li parentName="ul">{`SMTP Settings`}</li>
          <li parentName="ul">{`JWT and Cookie Secret Key`}</li>
        </ul>
        <p parentName="li">{`Save file and go back to root app direcotry`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`cd ../
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Install dependencies`}</strong></p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`yarn
`}</code></pre>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Setup database`}</strong></li>
    </ul>
    <p>{`Prepare database. At this step our database is empty. To add default data
(categories, products, pages), indexes and access token we need to run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`yarn setup <email> <domain>
`}</code></pre>
    <p>{`We don't have real domain, so we'll use our local domain:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm run setup admin@example.com http://localhost:3000
`}</code></pre>
    <p>{`You can change this email and domain anytime at Dashboard - Settings - General -
Domain and Settings - Personal Access Tokens.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Build project`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`yarn build
`}</code></pre>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Start application in the background`}</strong></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`pm2 start process.json
`}</code></pre>
    <p>{`Check that is cezerin apps is started fine and online:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`pm2 list all
`}</code></pre>
    <p>{`If all is fine, you can see somethng like this, status column must be online.
Not "error".`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`┌────┬────────────────────┬──────────┬──────┬───────────┬──────────┬──────────┐
│ id │ name               │ mode     │ O    │ status    │ cpu      │ memory   │
├────┼────────────────────┼──────────┼──────┼───────────┼──────────┼──────────┤
│ 0  │ api                │ fork     │ 2    │ online    │ 5.6%     │ 139.5mb  │
│ 1  │ store              │ fork     │ 3    │ online    │ 6.8%     │ 134.2mb  │
└────┴────────────────────┴──────────┴──────┴───────────┴──────────┴──────────┘
`}</code></pre>
    <p>{`If you have error status, you can check the log by this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`pm2 logs
`}</code></pre>
    <ul>
      <li parentName="ul">{`API running on port 3001 and available at `}<strong parentName="li">{`http://localhost:3001`}</strong></li>
      <li parentName="ul">{`Storefront running on port 3000 and available at `}<strong parentName="li">{`http://localhost:3000`}</strong></li>
      <li parentName="ul">{`Dashboard running on port 3000 and available at
`}<strong parentName="li">{`http://localhost:3000/admin`}</strong></li>
    </ul>
    <p>{`For example, here is the api method for store settings:
`}<strong parentName="p">{`http://localhost:3001/api/v1/settings`}</strong>{` and dashboard settings page:
`}<strong parentName="p">{`http://localhost:3000/admin/settings`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`[start-api] info: API running at http://localhost:3001
[start-api] info: MongoDB connected successfully
[start-store] info: Store running at http://localhost:3000
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      